import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '@/axios';

import { MediaLibraryData } from '../types';

export const MEDIA_LIBRARY_QUERY_KEY = 'mediaLibrary';

interface ListMediaResponse {
  success: boolean;
  message: string;
  data: MediaLibraryData;
}

// Listuje jeden poziom biblioteki mediów organizacji z Bytescale (przez backend,
// bo listowanie wymaga sekretnego klucza — publiczny klucz frontu nie ma praw).
// `path` = podścieżka względem korzenia `media` ("" = korzeń → foldery lat).
export const useMediaLibrary = (
  organizationId: string | null | undefined,
  path: string,
): UseQueryResult<MediaLibraryData, AxiosError> => useQuery<MediaLibraryData, AxiosError>({
  queryKey: [MEDIA_LIBRARY_QUERY_KEY, organizationId, path],
  queryFn: async () => {
    const response = await axiosInstance.get<ListMediaResponse>('/v3-listMediaLibrary', {
      params: { hotelId: organizationId, path },
    });
    return response.data.data;
  },
  enabled: !!organizationId,
  staleTime: 1000 * 60 * 2,
  refetchOnWindowFocus: false,
});
